import { fetchConfig } from "@/services/config";

const state = {
    config: [],
};

const mutations = {
    SET_CHILDREN(state, config) {
        state.config = config;
    },
};

const actions = {
    async fetchConfig({ commit }, user_id) {
        try {
            const config = await fetchConfig(user_id);
            commit('SET_CHILDREN', config);
        } catch (error) {
            commit('SET_ERROR', error.message);
        }
    },
};

const getters = {
    getConfig: state => state.config,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
